import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ugcRatingShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import { selectCurrentUserRatings, selectRatingsTransactions } from 'app/selectors/ugc/RatingsSelector';
import { selectCurrentUser } from 'app/selectors/AuthSelector';

import RatingsActions from 'app/actions/RatingsActions';

import UserRatingDropdown from './UserRatingDropdown';

export class UserRatingDropdownContainer extends React.PureComponent {
  componentDidMount() {
    if (this.props.currentUser && !this.props.userRating) {
      this.props.ratingsActions.getItemRatings([this.props.metadataId]);
    }
  }

  render() {
    return <UserRatingDropdown {...this.props} />;
  }
}

UserRatingDropdownContainer.propTypes = {
  metadataId: PropTypes.string.isRequired,
  ratingsActions: PropTypes.objectOf(PropTypes.func),
  ratingsTransactions: ImmutablePropTypes.map.isRequired,
  userRating: ugcRatingShape,
  useLibraryBranding: PropTypes.bool,
  currentUser: userIdentityShape
};

const mapStateToProps = (state, ownProps) => ({
  ratingsTransactions: selectRatingsTransactions(state),
  userRating: selectCurrentUserRatings(state).get(ownProps.metadataId),
  currentUser: selectCurrentUser(state)
});

const mapDispatchToProps = dispatch => ({
  ratingsActions: bindActionCreators(RatingsActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UserRatingDropdownContainer);
